import { aE as a, aQ as n } from "./StickyHeaderSkeleton-a6cd75ca.mjs";
import { l as o, A as e } from "./Header-6bea003a.mjs";
function u(r) {
  const {
    lang: s
  } = a();
  return o({
    queryKey: [e.CLIENT_V1_COURSE_CATEGORY, {
      lang: s
    }, "GNB_COURSE_CATEGORIES"],
    url: n(e.CLIENT_V1_COURSE_CATEGORY),
    options: {
      ...r,
      suspense: !1,
      cacheTime: 1 / 0,
      staleTime: 1 / 0,
      useErrorBoundary: !1
    }
  });
}
export {
  u
};
